<template>

  <Header></Header>

  <div v-if="type === 'customer'">
    <SearchCustomers @update-customers="searchCustomers" />
  </div>

  <div v-if="type === 'order'">
    <SearchOrders />
  </div>

  <div class="section container section--lg">
    <div class="content">
      <div class="heading">
        <h1 v-if="type === 'customer'">Customer Search Results</h1>
        <h1 v-if="type === 'order'">Orders Found</h1>
      </div>
      <CustomerTable v-if="type === 'customer'"
                     :requestCompleted="requestCompleted"
                     :no-data="'No customers found!'"
                     :rows="customers"
                     :displayTypes="true"
                     @row-click="viewCustomerDetails"/>
      <table class="table" v-if="type === 'order'">
        <thead>
          <tr>
            <th>Order #</th>
            <th>Name</th>
            <th>Order Date</th>
          </tr>
        </thead>
        <tbody v-if="orders.length > 0">
          <tr v-for="order in orders" :key="order.id">
            <td width="85px"><a href="/" @click.prevent="viewOrderDetails(order.order_number)" :class="`order__status--${order.status}`" class="col-num-order">{{ order.order_number }}</a></td>
            <td><a href="/" @click.prevent="viewOrderDetails(order.order_number)" :class="`order__status--${order.status}`" class="col-name">{{ order.customer.first_name }} {{ order.customer.last_name }}</a></td>
            <td><div class="col-date">{{ helpers.formatDate(order.created_at) }}</div></td>
          </tr>
        </tbody>
        <tbody v-if="!requestCompleted">
          <tr>
            <td colspan="3"><div class="loading-spinner" /></td>
          </tr>
        </tbody>
        <tbody v-if="orders.length === 0 && requestCompleted">
          <tr>
            <td colspan="3"><div class="col-no-results">No orders found!</div></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script>
import Header from '../components/Header.vue';
import SearchCustomers from '../components/SearchCustomers.vue';
import SearchOrders from '../components/SearchOrders.vue';
import CustomerTable from '../components/CustomerTable.vue';

export default {
  name: 'SearchResults',
  components: {
    Header, SearchCustomers, SearchOrders, CustomerTable
  },
  methods: {
    viewCustomerDetails(customer) {
      this.$router.push(`/customer/${customer.shopify_id}`);
    },
    viewOrderDetails(orderId) {
      this.$router.push(`/order/${orderId}`);
    },
    searchCustomers(term) {
      this.axios({
        method: 'get',
        url: `/v1/customers.json?query=${term}`
      })
        .then(response => {
          if (typeof response.data.records !== 'undefined') {
            this.customers = response.data.records;
          }
          this.requestCompleted = true;
        })
        .catch((error) => {
          console.log(error)
        });
    }
  },
  data() {
    return {
      customers: [],
      orders: [],
      type: this.$route.params.type,
      term: this.$route.params.term,
      requestCompleted: false
    }
  },
  mounted() {
    if(this.type === 'order') {
      this.axios.get(`/v1/orders/search/${this.term}`)
        .then(response => {
          let term = this.term;
          if(typeof response.data.records !== 'undefined') {
            let tempOrders = response.data.records.filter(function(e) {
              return (e.order_number.toString()).indexOf(term) > -1;
            });
            this.orders = tempOrders;
          }
          this.requestCompleted = true;
        })
       .catch((error) => { console.log(error) });
    } else {
      this.searchCustomers(this.term);
    }
  }
}
</script>
<style scoped>
.order__status--shipped {
  color: #D4B721;
}

.order__status--delivered {
  color: #089E56;
}

.order__status--draft {
color: #D43F21;
}

.order__status--expired {
  color: #C4C4C4;
}

.loading-spinner {
  background: url(../assets/images/loading_spinner.gif) no-repeat center center;
  width: 400px;
  height: 400px;
  margin: auto;
}
</style>

